import React, { useEffect } from 'react';
import { Redirect } from 'react-router-dom';
import trans from 'translate';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { createNotification } from '../../../redux/actions/uiActions';

export default function ErrorListner({ errorMsg, duration, redirectTo, onError, ...rest }) {
  const dispatch = useDispatch();

  useEffect(() => {
    if (!errorMsg) return;
    dispatch(createNotification('error', trans(errorMsg, undefined, undefined, false), duration));
  }, [errorMsg]);

  useEffect(() => {
    onError?.();
  }, []);

  return <>{redirectTo && errorMsg && <Redirect to={redirectTo} {...rest} />}</>;
}

ErrorListner.defaultProps = {
  duration: 3000,
  redirectTo: '',
  onError: () => {},
};

ErrorListner.propTypes = {
  errorMsg: PropTypes.string.isRequired,
  duration: PropTypes.number,
  onError: PropTypes.func,
  redirectTo: PropTypes.string,
};
